import type { FormDefData } from '../../Utils/types';
import { STRING, UI_TYPE_BINARY } from './FormTypes';

const formDef: FormDefData = {
  formId: 'CovidTestResult',
  behaviors: {
    lockWhenFinalized: true,
    saveOnComplete: true,
    clearOnIncomplete: true,
    clearOnNotApplicable: true,
  },
  sections: [
    {
      id: 1,
      title: '',
      fields: [
        {
          id: 1,
          title: 'Result',
          type: STRING,
          uiType: UI_TYPE_BINARY,
          responseOptions: ['Positive', 'Negative'],
          mandatory: false,
          tags: [],
        },
      ],
    },
  ],
};

export default formDef;
